module.exports = __webpack_public_path__ + "img/img_nengli@2x.85724bd6.png";